// Module
var code = "<div class=\"landing-page-section-content tw-h-auto lg:tw-min-h-screen\">\n    <div class=\"landing-page-section-content__background tw-absolute tw-w-full lg:tw-h-screen\" ng-class=\"$ctrl.backgroundClass\"></div>\n    <div class=\"landing-page-section-content__content tw-relative\" ng-transclude></div>\n</div>\n";
// Exports
module.exports = code;